/**
 * Name of the cookie carrying the browser's IANA timezone (for example
 * `Asia/Kolkata`), written by `ClientTimeZone` and read server-side by
 * `lib/server/clientTimeZone.ts`.
 *
 * A cookie rather than a header because a Server Component needs it during
 * render and the browser is the only authority on its own zone. Vercel does
 * expose `x-vercel-ip-timezone`, but that is geo-IP: a VPN or a traveller makes
 * it disagree with the browser, and a disagreement here silently prefetches a
 * key nobody reads. Not a secret, so it is readable by script by design.
 */
export const CLIENT_TIME_ZONE_COOKIE = 'clientTz';
